import { useState, useEffect } from "react";
import api from "../../../api/api";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import FormBranch from "../../../components/common/forms/FormBranch";
import FormPayment from "../../../components/common/forms/FormPayment";
import BackButton from "../../../components/common/backbutton/BackButton";
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../common/AdminSearchCustomer";
import NewFormPayment from "../../../components/common/forms/NewFormPayment";
import FormButtom from "../../../components/common/forms/FormButtom";


const DynamicDesignAndPrinting = () => {
  const { register, handleSubmit } = useForm();
  const { state } = useLocation();
  const [cmpId, setCmpId] = useState(null);

  const [uploadProof, setUploadProof] = useState("");

  const [searchData, setSearchData] = useState([]);
  // const [items, setItems] = useState([]);
  const [results, setResults] = useState({});
  const { user } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)



  useEffect(() => {
    api
      .get(`services/company/`)
      .then((response) => {
        // console.log(response.data)
        setSearchData(
          response.data.map(({ company_name: name, id }) => ({ name, id }))
        );
        // console.log(response.data[0].id)
        // setCmpId(response.data[0].id);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    api
      .get(`services/company/`)
      .then((response) => {
        // console.log(response.data)
        setSearchData(
          response.data.map(({ company_name: name, id }) => ({ name, id }))
        );
        // console.log(response.data[0].id)
        // setCmpId(response.data[0].id);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  };

  const handleOnSelect = (item) => {
    // the item selected
    // console.log(item)
    api
      .get(`/services/company/${item.id}/`)
      .then((response) => {
        // console.log("Result",response.data)
        setCmpId(response.data.id);

        setResults(response.data);
      })
      .catch((error) => {
        toast.error("something went wrong");
      });
  };

  const handleOnFocus = () => {
    // console.log('Focused')
  };

  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
      </>
    );
  };

  const onSubmit = (data) => {

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID
      }
    }

    data.type = state.Codename;
    // data.company = cmpId;

    api
      .post("/design-and-printing/", data)
      .then((response) => {
        // console.log(response.data)/
        toast.success("Data Registered Successfully");

        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.service_object_id,
        //   created_by: response.data.service_object_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : cmpId,
        //   transaction_type: "credit"

        // };


        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });

      })
      .catch((error) => {
        // console.log(error)
        toast.error("Data Registration Failed");
      });
  };

  return (
    <>
      <div>
        <div className="">
          <form className="px-10 lg:!px-14">
            <h1 className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
              {/* {slug.split("-")[0]} */}

              {state.ServiceName}
            </h1>
            <div className="mt-3">
              {

                (user?.user_type === "ST" || user?.user_type === "AD")
                && <AdminSearchCustomer
                  setUserId={setUserId}
                />
              }
            </div>
            {/* 
            <div className="mb-3" style={{ width: 400 }}>
              <ReactSearchAutocomplete
                items={searchData}
                onSearch={handleOnSearch}
                onHover={handleOnHover}
                onSelect={handleOnSelect}
                onFocus={handleOnFocus}
                autoFocus
                formatResult={formatResult}
                placeholder="Search Company"
              />
            </div> */}

            {/* company name details */}
            <div className="mt-5">

              <div className="flex justify-between">
                <p className=" text-lgn text-primary-blue font-Laila text-xl ">
                  क्यालेन्डर छपाईको लागि निम्नुसारको विवरण भरेर अर्डर गर्नुहोस ।
                </p>
                <p className="text-primary-red flex">
                  Firm No.
                  <p className=" text-primary-blue"> 1234</p>
                </p>
              </div>

              <div className="mt-4">
                <div className="flex-col flex md:flex-row flex-wrap">
                  <div className="flex flex-1 flex-wrap  border items-center m-0 px-2 border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      क्यालेन्डर छाप्ने कम्पनी वा ब्यवसायको नाम :
                    </label>
                    <input
                      type="text"
                      placeholder="e.g भरतपुर ट्रेदिङ् प्रा.ली."
                      // {...register("business_name", { required: false })}
                      value={results.company_name}
                      // name="company_name"
                      className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
                    />
                  </div>
                  <div className="flex flex-1 flex-wrap w-fit  border md:border-l-0 px-2 items-center border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      कम्पनीको ठेगाना :
                    </label>
                    <input
                      type="text"
                      placeholder="e.g भरतपुर - ११ , चितवन"
                      name="address"
                      // {...register("business_address", { required: false })}
                      className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
                      value={results.company_address}
                    />
                  </div>
                </div>
                <div className="flex-col flex md:flex-row">
                  <div className="flex flex-1 flex-wrap border items-center border-t-0 px-2 border-primary-blue">
                    <label className="border-primary-blue  flex-shrink-0 text-primary-red  text-lg font-bold">
                      दर्ता नं. :{" "}
                    </label>
                    <input
                      type="number"
                      placeholder="e.g ६०७६/५३४४३/३५"
                      {...register("reg_number", { required: false })}
                      className=" text-primary-blue w-[30%]  m-0  py-3 px-2 outline-none"
                    />
                  </div>
                  <div className="flex flex-1  border border-l-0 px-2 items-center border-t-0 border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      पान नं. :
                    </label>
                    <input
                      type="number"
                      placeholder="e.g १२३४५६६६५५"
                      {...register("pan_number", { required: false })}
                      className=" text-primary-blue w-[80%] m-0  py-3 px-3 outline-none"
                    />
                  </div>
                  <div className="flex flex-1 flex-wrap  border border-l-0 px-2 items-center border-t-0 border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      छपाई गर्दा राख्ने सम्पर्क नं. :
                    </label>
                    <input
                      type="number"
                      placeholder="e.g ९८००००००००"
                      // name="phone_nummber"
                      className=" text-primary-blue  m-0 px-3  outline-none"
                      {...register("contact_number", { required: false })}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-col flex mt-5 md:flex-row">
                <div className="flex flex-1 flex-wrap border items-center  px-2 border-primary-blue">
                  <label className="border-primary-blue  flex-shrink-0 text-primary-red  text-lg font-bold">
                    छपाई गर्ने साईज :
                  </label>
                  <input
                    type="text"
                    placeholder="e.g १५*२०"
                    {...register("printing_size", { required: false })}
                    // name="calander_size"
                    className=" text-primary-blue w-[50%]  m-0  py-3 px-3 outline-none"
                  />
                </div>
                <div className="flex flex-1 flex-wrap  border border-l-0 px-2 items-center  border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    पाना :
                  </label>
                  <input
                    type="number"
                    placeholder="e.g १२"
                    // name="paper_quatity"
                    {...register("pan_number", { required: false })}
                    className=" text-primary-blue w-[50%] px-3   outline-none"
                  />
                </div>
                <div className="flex flex-1  border border-l-0 px-2 items-center  border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    छपाई परिमाण :
                  </label>
                  <input
                    type="number"
                    placeholder="Type Here ............"
                    name="calander_quantity"
                    {...register("quantity", { required: false })}
                    className=" text-primary-blue w-[50%] m-0  py-3 px-3 outline-none"
                  />
                </div>
                <div className="flex flex-1 flex-wrap  border border-l-0 px-2 items-center  border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    लाग्ने जम्मा रकम :
                  </label>
                  <input
                    type="text"
                    placeholder="Type Here ............"
                    name="total_cost"
                    {...register("amount", { required: false })}
                    className=" text-primary-blue w-[50%]  px-3 outline-none"
                  />
                </div>
              </div>

              <div className="border-2  rounded-[2rem] align-middle border-red-600 mt-3">
                <p className="text-primary-blue mt-0 text-base font-medium leading-10 md:!text-lg text-center">
                  Service Fees Shown above are not inlcude any Goverment
                  Charges,VAT,Taxes,Fines,Penalties and Incidental costs
                </p>
              </div>
            </div>

            {/* company objective */}
            <div className="mt-5">
              <p className="text-primary-blue font-Calistoga  font-bold">
              2. Main Objectives  <span className="font-Laila"> अन्य केहि बिवरण दिनु पर्ने भएका यहाँ लेख्नुहोस् ।</span>
              </p>
              {/* text area */}
              <div className="mt-3">
                <textarea
                  // name=""
                  className="border-primary-blue w-full border p-3"
                  id=""
                  cols={30}
                  rows={10}
                  defaultValue={""}
                  // remarks
                  {...register("remarks", { required: false })}
                />
              </div>
            </div>
            {/* branch */}
            <div className="text-primary-blue font-Calistoga text-lg underline my-5">
              3. Working Branch
              <span className="text-primary-blue font-Laila underline text-base font-semibold mx-2">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
                नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>

            <FormBranch register={register} name="working_branch_code" />

            <FormButtom/>
            {/* sumbit modal */}
            
            <NewFormPayment
              handleSubmit={handleSubmit}
              handleClick={onSubmit}
              setUploadProof={setUploadProof}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default DynamicDesignAndPrinting;
